import { Mail, Wallet, Share2 } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import React, { useState } from 'react';
import ShareModal from '../ShareModal/ShareModal';

export default function BlackFooter() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {/* Share Modal */}
      <ShareModal isOpen={isModalOpen} onClose={closeModal} />

      {/* Footer */}
      <footer className="w-full mt-3 mb-1 absolute bottom-0 pb-2 hidden sm:flex md:flex lg:flex justify-center sm:justify-between px-4 text-[12px] text-center font-bold">
        <div className="flex items-center">
          <h1 className="hidden sm:block text-[11px] sm:text-[14px] text-white">© EXPOMORE 2025</h1>
          <h1 className=" ms-5 hidden lg:flex items-center sm:block text-[11px] sm:text-[14px] text-white">
            <Wallet className="h-[15px] w-[15px]" /> <span className="ms-1">Conversation Royalties</span>
          </h1>
        </div>
        {/* Middle */}
        <div className="flex items-center me-32 justify-between w-[300px]">
          <Link href="https://www.facebook.com/EXPOMORE" target="_blank">
            <Image
              src="/facebook.svg"
              alt="Expomore"
              width={100}
              height={100}
              className="hidden sm:block w-[20px] h-[20px]"
            />
          </Link>
          <Link href="https://www.instagram.com/EXPOMORE/" target="_blank">
            <Image
              src="/insta.svg"
              alt="Expomore"
              width={100}
              height={100}
              className="hidden sm:block w-[20px] h-[20px]"
            />
          </Link>
          <Link href="https://x.com/ExpomoreGlobal" target="_blank">
            <Image
              src="/twitter.svg"
              alt="Expomore"
              width={100}
              height={100}
              className="hidden sm:block w-[20px] h-[20px]"
            />
          </Link>
          <Link href="https://www.linkedin.com/company/ExpomoreGlobal" target="_blank">
            <Image
              src="/linkedin.svg"
              alt="Expomore"
              width={100}
              height={100}
              className="hidden sm:block w-[20px] h-[20px]"
            />
          </Link>
          <Link href="https://snapchat.com/t/ILxbhbeE" target="_blank">
            <Image
              src="/snap.svg"
              alt="Expomore"
              width={100}
              height={100}
              className="hidden sm:block w-[20px] h-[20px]"
            />
          </Link>
          <Link href="http://tiktok.com/@ExpomoreGlobal" target="_blank">
            <Image
              src="/tiktok.svg"
              alt="Expomore"
              width={100}
              height={100}
              className="hidden sm:block w-[20px] h-[20px]"
            />
          </Link>
          <Link href="https://www.youtube.com/@Expomore" target="_blank">
            <Image
              src="/youtube.svg"
              alt="Expomore"
              width={100}
              height={100}
              className="hidden sm:block w-[20px] h-[20px]"
            />
          </Link>
        </div>

        <div className="flex items-center">
          <button
            onClick={openModal}
            className="hidden lg:flex items-center mr-4 text-[11px] sm:text-[14px] text-white hover:text-white"
          >
            <Share2 className="h-[15px] w-[15px]" /> <span className="ms-1">Share EXPOMORE</span>
          </button>
          <h1 className="hidden lg:flex items-center sm:block text-[11px] sm:text-[14px] text-white">
            <Mail className="h-[15px] w-[15px]" /> <span className="ms-1">support@EXPOMORE.com</span>
          </h1>
        </div>
      </footer>
    </>
  );
}
